import { MetaData, PropertySalesStatus, RequestState } from '../../types';

import { formatApiResult } from '../../utils/formatApiResult';
import useApi from '../api';

interface PropertySalesSatusResponse {
  isLoading: boolean;
  state: RequestState;
  error?: string;
  data: Array<PropertySalesStatus>;
  metadata: MetaData;
}

export const useGetPropertySalesStatuses = () => {
  const [propertySalesStatuses] = useApi.get({
    url: `/sales-status`,
  });

  return formatApiResult(propertySalesStatuses) as PropertySalesSatusResponse;
};
